document.addEventListener('easysearch_loaded', function (e) {
	var easysearch_container = $('#easysearch-container');
    if(easysearch_container.length) {
      var selects = easysearch_container.find('select');
      checkSelectors(selects);
      if(selects.length){
        $.each(selects, function(i, v) {
          $(v).on('change', function(){checkSelectors(selects);});
        });
      }
    }
  	
  	function checkSelectors(selects) {
      setTimeout(function() {
        $.each(selects, function(i, v) {
          if(!$(v).prop('disabled')) {
            if($(v).val().length) {
              $(v).parent().addClass('is_checked');
              $(v).removeClass('is_mark');
            } else {
              $(v).addClass('is_mark');
              $(v).parent().removeClass('is_checked');
            }
          } else {
          	$(v).removeClass('is_mark');
            $(v).parent().removeClass('is_checked');
          }
        });
      	var Indexes = easysearch.curIndex.split(",");
      }, 1000);
	}
});